<script lang="ts">
  import BlockReskinLogo from './reskin_logos/BlockReskinLogo.svelte';

  interface Props {
    size?: string;
  }

  let { size = 'inherit' }: Props = $props();
</script>

<a href="/" class={`logo size-${size}`} aria-label="visit home page" data-testid="logo">
  <BlockReskinLogo />
</a>

<style lang="scss">
  .logo {
    display: block;
    width: inherit;
    height: inherit;
    color: black;
    transition: fill 0.2s ease;
    cursor: pointer;

    &:hover {
      color: #666666;
    }

    &.size-20 {
      width: 20px;
      height: 20px;
    }

    &.size-32 {
      width: 32px;
      height: 32px;
    }

    &.size-40 {
      width: 40px;
      height: 40px;
    }

    &.size-80 {
      width: 80px;
      height: 80px;
    }

    &.size-200 {
      width: 200px;
      height: 200px;
    }
  }

  .logo-height {
    height: var(--logo-height);
  }

  .logo-width {
    width: var(--logo-width);
  }
</style>
